import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withModifiers as _withModifiers, vModelCheckbox as _vModelCheckbox, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-466b453c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "title is-size-4 has-text-centered mb-6" }, "Technology", -1))
const _hoisted_3 = { class: "columns" }
const _hoisted_4 = { class: "column" }
const _hoisted_5 = { class: "field" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "is-size-7 has-text-danger" }, "*"),
  /*#__PURE__*/_createTextVNode(" Technology description "),
  /*#__PURE__*/_createElementVNode("span", {
    class: "icon is-size-7 has-text-grey-light has-tooltip-multiline",
    "data-tooltip": "Please describe en few lines the innovation of your project, technology/s"
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fas fa-question-circle" })
  ])
], -1))
const _hoisted_7 = { class: "control" }
const _hoisted_8 = {
  key: 0,
  class: "help is-danger"
}
const _hoisted_9 = { class: "field" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "is-size-7 has-text-danger" }, "*"),
  /*#__PURE__*/_createTextVNode(" TRL/phase of Technology development "),
  /*#__PURE__*/_createElementVNode("span", {
    class: "icon is-size-7 has-text-grey-light has-tooltip-multiline",
    "data-tooltip": "Please select the current technology readiness level of your innovation"
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fas fa-question-circle" })
  ])
], -1))
const _hoisted_11 = { class: "control" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: undefined }, "Select ...", -1))
const _hoisted_13 = ["value"]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, "Other...", -1))
const _hoisted_15 = {
  key: 1,
  class: "control has-icons-right"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times is-danger" }, null, -1))
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = {
  key: 2,
  class: "help is-danger"
}
const _hoisted_19 = { class: "column" }
const _hoisted_20 = { class: "field" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "is-size-7 has-text-danger" }, "*"),
  /*#__PURE__*/_createTextVNode(" Intellectual Property (IP) "),
  /*#__PURE__*/_createElementVNode("span", {
    class: "icon is-size-7 has-text-grey-light has-tooltip-multiline",
    "data-tooltip": "Please select if your innovation/technology has already any IP rights"
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fas fa-question-circle" })
  ])
], -1))
const _hoisted_22 = { class: "control" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "has-text-grey is-size-7 has-text-left mt-2 mb-2" }, " IP is protected in law by, for example, patents, copyright and trademarks, which enable people to earn recognition or Financial benefit from what they invent or create. ", -1))
const _hoisted_24 = { class: "field columns" }
const _hoisted_25 = { class: "column" }
const _hoisted_26 = /*#__PURE__*/_createTextVNode(" Patent ")
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_28 = /*#__PURE__*/_createTextVNode(" Copyright ")
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_30 = /*#__PURE__*/_createTextVNode(" Industrial design rights ")
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_32 = /*#__PURE__*/_createTextVNode(" Plant varieties ")
const _hoisted_33 = { class: "column" }
const _hoisted_34 = /*#__PURE__*/_createTextVNode(" Trademarks ")
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_36 = /*#__PURE__*/_createTextVNode(" Trade dress ")
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_38 = /*#__PURE__*/_createTextVNode(" Trade secret ")
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_40 = /*#__PURE__*/_createTextVNode(" Other ")
const _hoisted_41 = {
  key: 0,
  class: "field"
}
const _hoisted_42 = { class: "control" }
const _hoisted_43 = {
  key: 1,
  class: "field"
}
const _hoisted_44 = { class: "control" }
const _hoisted_45 = {
  key: 2,
  class: "field"
}
const _hoisted_46 = { class: "control" }
const _hoisted_47 = {
  key: 3,
  class: "field"
}
const _hoisted_48 = { class: "control" }
const _hoisted_49 = {
  key: 4,
  class: "field"
}
const _hoisted_50 = { class: "control" }
const _hoisted_51 = {
  key: 5,
  class: "field"
}
const _hoisted_52 = { class: "control" }
const _hoisted_53 = {
  key: 6,
  class: "field"
}
const _hoisted_54 = { class: "control" }
const _hoisted_55 = {
  key: 7,
  class: "field"
}
const _hoisted_56 = { class: "control" }
const _hoisted_57 = {
  key: 8,
  class: "help is-danger"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.active)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _createElementVNode("div", _hoisted_7, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.data.techDescr) = $event)),
                  type: "text",
                  class: _normalizeClass(["input", { 'is-danger': _ctx.errors.techDescr }])
                }, null, 2), [
                  [_vModelText, _ctx.data.techDescr]
                ])
              ]),
              (_ctx.errors.techDescr)
                ? (_openBlock(), _createElementBlock("p", _hoisted_8, "This field is required"))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_9, [
              _hoisted_10,
              _createElementVNode("div", _hoisted_11, [
                (!_ctx.custom.trl)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: _normalizeClass(["select is-fullwidth", { 'is-danger': _ctx.errors.trlId }])
                    }, [
                      _withDirectives(_createElementVNode("select", {
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.data.trlId) = $event)),
                        onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.selectHasInput($event.target.selectedIndex, $event.target.length)))
                      }, [
                        _hoisted_12,
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.trls, (item) => {
                          return (_openBlock(), _createElementBlock("option", {
                            value: item.key,
                            key: item.key
                          }, _toDisplayString(item.value), 9, _hoisted_13))
                        }), 128)),
                        _hoisted_14
                      ], 544), [
                        [_vModelSelect, _ctx.data.trlId]
                      ])
                    ], 2))
                  : (_openBlock(), _createElementBlock("div", _hoisted_15, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.data.trlCustom) = $event)),
                        class: _normalizeClass(["input", { 'is-danger': _ctx.errors.trlId }]),
                        placeholder: "Enter your custom description",
                        type: "text"
                      }, null, 2), [
                        [_vModelText, _ctx.data.trlCustom]
                      ]),
                      _createElementVNode("span", {
                        class: "icon is-small is-right pointer",
                        onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => {_ctx.data.trlCustom = ''; _ctx.custom.trl = false}, ["prevent"]))
                      }, _hoisted_17)
                    ])),
                (_ctx.errors.trlId)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_18, "This field is required"))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, [
              _hoisted_21,
              _createElementVNode("div", _hoisted_22, [
                _hoisted_23,
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("div", _hoisted_25, [
                    _createElementVNode("label", null, [
                      _withDirectives(_createElementVNode("input", {
                        type: "checkbox",
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.custom.ip.patent) = $event))
                      }, null, 512), [
                        [_vModelCheckbox, _ctx.custom.ip.patent]
                      ]),
                      _hoisted_26
                    ]),
                    _hoisted_27,
                    _createElementVNode("label", null, [
                      _withDirectives(_createElementVNode("input", {
                        type: "checkbox",
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.custom.ip.copyright) = $event))
                      }, null, 512), [
                        [_vModelCheckbox, _ctx.custom.ip.copyright]
                      ]),
                      _hoisted_28
                    ]),
                    _hoisted_29,
                    _createElementVNode("label", null, [
                      _withDirectives(_createElementVNode("input", {
                        type: "checkbox",
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.custom.ip.idr) = $event))
                      }, null, 512), [
                        [_vModelCheckbox, _ctx.custom.ip.idr]
                      ]),
                      _hoisted_30
                    ]),
                    _hoisted_31,
                    _createElementVNode("label", null, [
                      _withDirectives(_createElementVNode("input", {
                        type: "checkbox",
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.custom.ip.pv) = $event))
                      }, null, 512), [
                        [_vModelCheckbox, _ctx.custom.ip.pv]
                      ]),
                      _hoisted_32
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_33, [
                    _createElementVNode("label", null, [
                      _withDirectives(_createElementVNode("input", {
                        type: "checkbox",
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.custom.ip.trademark) = $event))
                      }, null, 512), [
                        [_vModelCheckbox, _ctx.custom.ip.trademark]
                      ]),
                      _hoisted_34
                    ]),
                    _hoisted_35,
                    _createElementVNode("label", null, [
                      _withDirectives(_createElementVNode("input", {
                        type: "checkbox",
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.custom.ip.td) = $event))
                      }, null, 512), [
                        [_vModelCheckbox, _ctx.custom.ip.td]
                      ]),
                      _hoisted_36
                    ]),
                    _hoisted_37,
                    _createElementVNode("label", null, [
                      _withDirectives(_createElementVNode("input", {
                        type: "checkbox",
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.custom.ip.ts) = $event))
                      }, null, 512), [
                        [_vModelCheckbox, _ctx.custom.ip.ts]
                      ]),
                      _hoisted_38
                    ]),
                    _hoisted_39,
                    _createElementVNode("label", null, [
                      _withDirectives(_createElementVNode("input", {
                        type: "checkbox",
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.custom.ip.other) = $event))
                      }, null, 512), [
                        [_vModelCheckbox, _ctx.custom.ip.other]
                      ]),
                      _hoisted_40
                    ])
                  ])
                ]),
                (_ctx.custom.ip.patent)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                      _createElementVNode("p", _hoisted_42, [
                        _withDirectives(_createElementVNode("input", {
                          placeholder: "Patent number",
                          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.data.ipPatent) = $event)),
                          class: "input",
                          type: "text"
                        }, null, 512), [
                          [_vModelText, _ctx.data.ipPatent]
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.custom.ip.copyright)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                      _createElementVNode("p", _hoisted_44, [
                        _withDirectives(_createElementVNode("input", {
                          placeholder: "Copyright number",
                          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.data.ipCopyright) = $event)),
                          class: "input",
                          type: "text"
                        }, null, 512), [
                          [_vModelText, _ctx.data.ipCopyright]
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.custom.ip.idr)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                      _createElementVNode("p", _hoisted_46, [
                        _withDirectives(_createElementVNode("input", {
                          placeholder: "Description of Industrial design rights",
                          "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.data.ipIndustrial) = $event)),
                          class: "input",
                          type: "text"
                        }, null, 512), [
                          [_vModelText, _ctx.data.ipIndustrial]
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.custom.ip.pv)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                      _createElementVNode("p", _hoisted_48, [
                        _withDirectives(_createElementVNode("input", {
                          placeholder: "Plant varieties number",
                          "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.data.ipPlant) = $event)),
                          class: "input",
                          type: "text"
                        }, null, 512), [
                          [_vModelText, _ctx.data.ipPlant]
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.custom.ip.trademark)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                      _createElementVNode("p", _hoisted_50, [
                        _withDirectives(_createElementVNode("input", {
                          placeholder: "Trademarks description / number",
                          "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.data.ipTrademark) = $event)),
                          class: "input",
                          type: "text"
                        }, null, 512), [
                          [_vModelText, _ctx.data.ipTrademark]
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.custom.ip.td)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                      _createElementVNode("p", _hoisted_52, [
                        _withDirectives(_createElementVNode("input", {
                          placeholder: "Trade dress description/register number",
                          "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.data.ipTradeDress) = $event)),
                          class: "input",
                          type: "text"
                        }, null, 512), [
                          [_vModelText, _ctx.data.ipTradeDress]
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.custom.ip.ts)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                      _createElementVNode("p", _hoisted_54, [
                        _withDirectives(_createElementVNode("input", {
                          placeholder: "Trade secret description/register number",
                          "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.data.ipTradeSecret) = $event)),
                          class: "input",
                          type: "text"
                        }, null, 512), [
                          [_vModelText, _ctx.data.ipTradeSecret]
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.custom.ip.other)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                      _createElementVNode("p", _hoisted_56, [
                        _withDirectives(_createElementVNode("input", {
                          placeholder: "Other description / numbers",
                          "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.data.ipOther) = $event)),
                          class: "input",
                          type: "text"
                        }, null, 512), [
                          [_vModelText, _ctx.data.ipOther]
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.errors.ip)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_57, "This field is required"))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}